import axios from 'axios';
import { urlPaymentReceipt } from '../utils';

export const apiPaymentReceipt = axios.create({
    baseURL: `${urlPaymentReceipt}`
});